import type { CopilotScope } from "@productlane/lib/src/ai"
import { copilotScopeKey } from "@productlane/lib/src/ai"

export function shouldApplyAllocatedSession({
	allocated,
	streamScopeKey,
	allocatedWithFresh,
	state,
}: {
	allocated: string
	streamScopeKey: string
	allocatedWithFresh: boolean
	state: {
		sessionId: string | null
		scope: CopilotScope | null
		requireFreshSession: boolean
	}
}): boolean {
	if (!state.scope || copilotScopeKey(state.scope) !== streamScopeKey) {
		return false
	}
	if (state.sessionId !== null && state.sessionId !== allocated) {
		return false
	}
	if (state.requireFreshSession && !allocatedWithFresh) {
		return false
	}
	return true
}
